import React from 'react';
import QualificationMatrix from '../components/QualificationMatrix';

const QualificationMatrixPage: React.FC = () => {
  return <QualificationMatrix />;
};

export default QualificationMatrixPage;
